// extracted by mini-css-extract-plugin
export default {"toastFixed":"toster_toastFixed__RJDdn"};